import React from 'react';
import { Field, useFormikContext } from 'formik';

import './AuControlInput.scss';

export interface IAuControlInput {
  name: string;
  label: string | React.ReactElement;
  id: string;
  value?: string | number;
  type: 'checkbox' | 'radio';
  className?: string;
  small?: boolean;
  block?: boolean;
  dark?: boolean;
  alt?: boolean;
  style?: React.CSSProperties;
  hintText?: string | null;
  disabled?: boolean;
}

/**
 * The control input component
 * Used for both checkboxes and radio buttons
 *
 */
const AuControlInput: React.FC<IAuControlInput> = ({ name, value, id, label, type, dark, alt, small, block, hintText, className = '', disabled = false, ...attributeOptions }) => {
  const form = useFormikContext();

  return (
    <>
      <div className={
        `au-control-input ${className}` +
        `${dark ? ' au-control-input--dark' : ''}` +
        `${alt ? ' au-control-input--alt' : ''}` +
        `${small ? ' au-control-input--small' : ''}` +
        `${block ? ' au-control-input--block' : ''}` +
        `${form.getFieldMeta(name).error && !disabled ? ' au-control-input--invalid' : ''}`
      }
      >
        <Field
          className='au-control-input__input'
          name={name}
          id={id}
          type={type}
          value={value ? value : undefined}
          disabled={disabled}
          {...attributeOptions}
        />
        <label className='au-control-input__text' htmlFor={id}>
          {label}
          {hintText &&
            <>
              {label && <br />}
              <span className='au-control-input__hint-text'>{hintText}</span>
            </>
          }
        </label>
      </div>
    </>
  );
};

export default AuControlInput;